import styled from "styled-components";

export const StyledFormWrapper = styled.div`
    display: flex;
    flex: 1;

    .ant-form {
        display: flex;
        flex-direction: column;
        gap: 16px;
        flex: 1;
    }
`;
